import TabButton from './TabButton';
import TabButtonEvents from '../events/TabButtonEvents';
import TabButtonIds from '../data/TabButtonIds';
import { getMovieClipByName, Stage } from '../utils/utils';

// ==================================================================================================
type TabButtonCallback = (...args: unknown[]) => void;

export default class TabButtons {
  // ================================================================================================
  // properties
  // ================================================================================================
  private buttons: TabButton[];

  private stage: Stage;

  private _selectedTabButtonId: TabButtonIds;

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor(stage: Stage) {
    this.stage = stage;
    this.initTabButtons();
  }

  // ----------------------------------------------------------------------------------------------
  get selectedTabButtonId(): TabButtonIds {
    return (this._selectedTabButtonId);
  }

  // ----------------------------------------------------------------------------------------------
  set selectedTabButtonId(value: TabButtonIds) {
    this.selectButtonAt(value);
  }

  // ================================================================================================
  // private
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  private initTabButton(buttonName: string, pressedCallback: TabButtonCallback): TabButton {
    const tabButton = new TabButton(getMovieClipByName(this.stage, buttonName));
    if (!tabButton) {
      console.warn(`tab button with name '${buttonName}' not found on the stage`);
      return (null);
    }

    tabButton.events.on(TabButtonEvents.PRESSED, pressedCallback, this);
    return (tabButton);
  }

  // ----------------------------------------------------------------------------------------------
  private initTabButtons(): void {
    this.buttons = [
      this.initTabButton('mainColor', this.onMainTabButtonPressed),
      this.initTabButton('secondColor', this.onSecondTabButtonPressed),
      this.initTabButton('thirdColor', this.onThirdTabButtonPressed),
    ];
  }

  // ----------------------------------------------------------------------------------------------
  private onMainTabButtonPressed(): void {
    this.selectButtonAt(TabButtonIds.MAIN);
  }

  // ----------------------------------------------------------------------------------------------
  private onSecondTabButtonPressed(): void {
    this.selectButtonAt(TabButtonIds.SECOND);
  }

  // ----------------------------------------------------------------------------------------------
  private onThirdTabButtonPressed(): void {
    this.selectButtonAt(TabButtonIds.THIRD);
  }

  // ----------------------------------------------------------------------------------------------
  private selectButtonAt(tabButtonId: TabButtonIds): void {
    this._selectedTabButtonId = tabButtonId;

    this.buttons.forEach((button, index) => {
      button.isSelected = tabButtonId === index;
    });
  }
}
